<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>

  <div class="pointer ms-auto">
      <fa-icon icon="times" (click)="activeModal.dismiss()" (keydown.enter)="activeModal.dismiss()"></fa-icon>
    </div>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
</div>
<div class="modal-footer">
  <button *ngIf="showCancel" type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
    {{ cancelText }}
  </button>
  <button type="button" class="btn" [ngClass]="confirmButtonClass" (click)="activeModal.close(true)">
    {{ confirmText }}
  </button>
</div>
